// REACT
import React from 'react'

// ESTILOS
import Styles from './Scroll.module.css'

// PROPIEDADES
interface ScrollProps {
	dark: boolean
	className?: string
	action?: () => any
}

const Scroll: React.FC<ScrollProps> = (props: ScrollProps) => {
	return (
		<button className={`${Styles.btn} ${props.className}`} onClick={props.action}>
			<img
				className={Styles.img}
				src={require(`Assets/General/scroll-down${props.dark ? '-dark' : ''}.png`)}
				alt='Scroll icon'
			/>
		</button>
	)
}

export default Scroll
